<template>
  <div style="background-color: white">
    <a-breadcrumb style="padding: 16px 24px">
      <a-breadcrumb-item>
        <router-link :to="{name:'scf'}">
          <a-icon type="home"/>
          <span>首页</span>
        </router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item href="">
        <router-link :to="{name:'news'}">
          <span>大事记</span>
        </router-link>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <div style="margin:24px;min-height: 500px">
      <div class="timeline-small">
        <div class="timeline-small-body">
          <ul>
            <li v-for="(item, index) in events" :key="index">
              <div class="bullet blue"></div>
              <div class="date">{{item.date}}</div>
              <div class="desc">
                <h3>{{ item.name }}</h3>
                <p class="text-muted">{{ item.desc }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>

    </div>


  </div>
</template>

<script>
import {getEventList} from "../../api/api";
import {filterUnderLine} from "../../../static/js/util";


export default {
  name: "Events",
  data() {
    return {
      events: '',
    };
  },
  mounted() {
    getEventList().then(res => {
      this.events = filterUnderLine(res.data.results)


    }).catch((err) => {
      console.log(err)
    })

  },
  methods: {},
}
</script>

<style scoped>
.timeline-small {
  margin: 30px auto 0;
  font-family: 'Open Sans', sans-serif;

}

.timeline-small-body ul {
  padding: 1em 0 0 2em;
  margin: 0;
  list-style: none;
  position: relative;

}

.timeline-small-body ul::before {
  content: ' ';
  height: 100%;
  width: 1px;
  /*background-color: var(--primaryColor);*/
  border: dodgerblue 2px dashed;
  position: absolute;
  top: 0;
  left: 2.4em;
  z-index: 0;
}

.timeline-small-body li div {
  display: inline-block;
  margin: 1em 0;
  vertical-align: top;
}

.timeline-small-body .bullet {
  width: 1rem;
  height: 1rem;
  box-sizing: border-box;
  border-radius: 50%;
  background: #fff;
  z-index: 1;
  margin-right: 1rem;
  vertical-align: top;
}

.timeline-small-body .bullet.blue {
  background-color: dodgerblue;
  border: 3px solid #B0E8E2;
}


.timeline-small-body .date {
  font-size: 0.75em;
  padding-top: 0.40rem;
  padding-right: 1rem;
  vertical-align: center;
}

.timeline-small-body .desc {
  width: 50%;
}

.timeline-small-body h3 {
  font-size: 0.9em;
  font-weight: 400;
  margin: 0;
}

.timeline-small-body h4 {
  margin: 0;
  font-size: 0.7em;
  font-weight: 400;
  color: #808080;
}


</style>



// WEBPACK FOOTER //
// src/components/content/Events.vue